import * as React from 'react';
import _ from 'lodash';

import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { setMarkets } from '../../redux/ui/actions';
import { RootState } from '../../redux/types';
import { MultiSelector } from '../../components/core/MultiSelector';
import { Market } from '../../api/markets.types';
import { useCallback } from 'react';
import { DropdownMenuItemType } from '@fluentui/react';

export const MarketSelector = ({ hideLabel }: { hideLabel?: boolean }) => {
  const dispatch = useDispatch();
  const marketCodes = useSelector((state: RootState) => state.ui.markets);
  const markets = useSelector((state: RootState) => state.markets.markets);

  const allOptions = useMemo(() => {
    if (!markets.data || markets.data.length === 0) {
      return [];
    }

    const options: any[] = [];

    const regions = _.groupBy(markets.data, 'region');
    _.keys(regions).forEach((region) => {
      const regionMarkets: Market[] = regions[region];

      // Region
      options.push({
        key: 'header_' + regionMarkets.map((i) => i.code).join('_'),
        text: region !== 'null' ? region : 'Other',
        level: 0,
        itemType: DropdownMenuItemType.Header,
      });

      const groups = _.groupBy(regionMarkets, 'groupCode');
      for (let group in groups) {
        // Group
        options.push({
          key: 'header_' + groups[group].map((j) => j.code).join('_'),
          text: `Group ${group}`,
          level: 1,
          itemType: DropdownMenuItemType.Header,
        });

        groups[group].forEach((m) => {
          // Market
          options.push({
            key: m.code,
            text: `${m.name} (${m.code})`,
            level: 2,
          });
        });
      }
    });

    return options;
  }, [markets.data]);

  const onChange = useCallback(
    (codes: string[]) => {
      const result = _.flatMap(codes.map((m) => m.split('_')));
      dispatch(setMarkets(result));
    },
    [dispatch]
  );

  return (
    <MultiSelector
      hideAll={true}
      disabled={markets.isFetching}
      label={hideLabel ? undefined : 'Markets'}
      placeholder={markets.isFetching ? 'Loading markets...' : 'Select markets'}
      items={allOptions as any}
      selectedKeys={marketCodes}
      onChange={onChange}
      styles={{ width: 210 }}
      testId="dd_market"
    />
  );
};
